// SAMPLE QUOTES — illustrative placeholders. Replace with real, permissioned
// testimonials before publishing. The UI marks them as samples until `sample: false`.
export const TESTIMONIALS = [
  {
    quote: "Dad's shoebox became a folder my sister and I could both open. The reminder about his home policy arrived three weeks before it lapsed.",
    name: "Priya",
    role: "Caring for a parent",
    networks: ["facebook", "instagram", "hub"],
    sample: true,
  },
  {
    quote: "I watched the one-minute tour, then set the whole thing up during my lunch break. Executor access took one more tap.",
    name: "Marcus",
    role: "Parent of two",
    networks: ["youtube", "facebook", "hub"],
    sample: true,
  },
  {
    quote: "Clients finally keep the plan current. The portal shows me what's missing before the annual review, not after.",
    name: "Elena",
    role: "Estate attorney",
    networks: ["linkedin", "hub"],
    sample: true,
  },
  {
    quote: "Five minutes a week. One paper, one habit. The drawer is empty and I know where everything is.",
    name: "Tom",
    role: "Household organiser",
    networks: ["instagram", "facebook"],
    sample: true,
  },
];

export const testimonialsFor = (key) => TESTIMONIALS.filter((t) => t.networks.includes(key)).slice(0, 3);
